import {OPEN_CLOSE_MODAL} from '../constants/actionTypes';
import {NOTIFICATION_MODAL_TYPE} from '../constants/identifiers';

export function openCloseModal(modalType) {
    return {type: OPEN_CLOSE_MODAL, modalType};
}

export function showPlatformNotification(
    notificationType,
    title,
    text,
    isNotificationLocalizable,
    notificationWildCards = [],
    isDismissible = true
) {
    return {
        type: OPEN_CLOSE_MODAL,
        modalType: NOTIFICATION_MODAL_TYPE,
        notificationType,
        notificationTitle: title,
        notificationText: text,
        isNotificationLocalizable,
        notificationWildCards,
        isNotificationDismissible: isDismissible
    };
}



// WEBPACK FOOTER //
// ./src/actions/modalActions.js